<template>
  <div>
    <LayoutIntroductionHeaderComponent :page="page" />
    <pagesEventsQueryComponent />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const page = baseStrapiGetAttributes(props.data)

</script>

<style module>
</style>
